// Central UI helper for tier / customer_type labels.
// See backend/utils/tier_labels.py — must stay in sync.
export const TIER_LABELS = {
  partner: 'Master Distributor',
  iptv_distributor: 'Sub Distributor',
  lco: 'LCO',
  corporate: 'Corporate',
  leased_line: 'Leased Line',
  bulk_bandwidth: 'Bulk Bandwidth',
  broadband: 'Broadband',
};

export const tierLabel = (customerType) => {
  if (!customerType) return '—';
  return TIER_LABELS[customerType] || customerType.replace(/_/g, ' ');
};
